import { Routes } from '@angular/router';

import { RootComponent } from '../root/root.component';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
import { ImportComponent } from './import/import.component';
import { SummaryComponent } from './summary/summary.component';

import { AuthGuard } from '../auth.guard';

export const routing: Routes = [
  {
    path: 'customer',
    data: {
      breadcrumb_en: 'Customers',
      breadcrumb_es: 'Clientes'
    },
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      {
        path: '',
        component: ListComponent,
        data: {
          breadcrumb_en: 'Customer List',
          breadcrumb_es: 'Lista de Clientes'
        },
      },
      {
        path: 'list',
        component: ListComponent,
        data: {
          breadcrumb_en: 'Customer List',
          breadcrumb_es: 'Lista de Clientes'
        },
      },
      {
        path: 'add',
        component: AddComponent,
        data: {
          breadcrumb_en: 'Add New Customer',
          breadcrumb_es: 'Agregar Cliente'
        },
      },
      {
        path: 'import',
        component: ImportComponent,
        data: {
          breadcrumb_en: 'Import Customers',
          breadcrumb_es: 'Importar Clientes'
        },
      },
      {
        path: ':customerId',
        component: SummaryComponent,
        data: {
          breadcrumb_en: 'Edit Customer',
          breadcrumb_es: 'Editar Cliente'
        },
      },
    ]
  }
];
